import * as React from "react";
import MuiRegularButton, { MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";

const ButtonCardAction: React.FC<MuiRegularButtonProps> = (props) => {
    const { children, ...rest } = props;
    return (
        <MuiRegularButton simple {...rest}>
            {children}
        </MuiRegularButton>
    );
};

ButtonCardAction.defaultProps = {
    color: "transparent",
};

export default ButtonCardAction;
